import axios from 'axios'

const API_BASE_URL = 'https://btc-services.btc.bw/api';
// Define a reusable axios instance
const loginClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

interface LoginCredentials {
    username: string
    password: string
}



export const submitLogin = async (loginCredentials: LoginCredentials) => {

    try {
        const response = await loginClient.post("/login", loginCredentials);
        return response.data; // Return the response data if needed
    } catch (error: any) {
        if (error.response) {
            // Server responded with a status other than 200 range
            console.error('Error response:', error.response.data);
            return (error.response.data);
        } else if (error.request) {
            // No response was received
            console.error('Error request:', error.request);
            throw new Error('No response received. Please try again.');
        } else {
            // Something else happened
            console.error('Error', error.message);
            throw new Error('An error occurred. Please try again.');
        }
    }
}







// export const submitLogin = async (loginCredentials: LoginCredentials) => {
//
//     let data = qs.stringify({
//         client_id: 'btc-ad_client',
//         username: loginCredentials.username + '@btc.bw',
//         password: loginCredentials.password,
//         grant_type: 'password',
//         client_secret: 'kgJAQuPkZ94JteTEbK8lh3cS2lIuUqOY',
//         scope: 'openid',
//     })
//
//     try{
//         const response = await loginClient.post('/', data);
//         console.log(response);
//         return response.data;
//
//     }
//     catch(error: any){
//
//         if (error.response) {
//             console.error('Error response:', error.response.data);
//             throw new Error(error.response.data.message || 'Transaction submission failed');
//         } else if (error.request) {
//             // No response was received
//             console.error('Error request:', error.request);
//             throw new Error('No response received. Please try again.');
//         } else {
//             // Something else happened
//             console.error('Error', error.message);
//             throw new Error('An error occurred. Please try again.');
//         }
//     }
// }
